import React from "react";

const Welcome = () => (
  <div className="center">
    Welcome
    <br />
    Please select a part to start
  </div>
);

export default Welcome;
